import { makeStyles, tokens, Text } from '@fluentui/react-components';
import { TRUST_STATS } from './data';
import { MOBILE_BREAKPOINT } from './constants';
import { ottoTokens } from '@/theme/ottoTokens';

const useStyles = makeStyles({
  section: {
    paddingBlock: '40px',
    borderBlockStartStyle: 'solid',
    borderBlockStartWidth: '1px',
    borderBlockStartColor: tokens.colorNeutralStroke2,
    borderBlockEndStyle: 'solid',
    borderBlockEndWidth: '1px',
    borderBlockEndColor: tokens.colorNeutralStroke2,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  inner: {
    maxWidth: '1200px',
    marginInline: 'auto',
    paddingInline: tokens.spacingHorizontalXXL,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: tokens.spacingHorizontalXXL,
    alignItems: 'center',
    [`@media (max-width: ${MOBILE_BREAKPOINT})`]: {
      // Stays three across on mobile — the numbers are short enough that
      // 33% widths still read at a glance, and stacking them vertically
      // breaks the "platform reach" rhythm. Only the gutter + padding
      // shrink to keep the values from crashing into each other.
      gap: tokens.spacingHorizontalL,
      paddingInline: tokens.spacingHorizontalL,
    },
  },
  item: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  value: {
    display: 'block',
    fontSize: 'clamp(24px, 4vw, 32px)',
    fontWeight: tokens.fontWeightBold,
    letterSpacing: '-0.02em',
    lineHeight: 1,
    backgroundImage: ottoTokens.landingPrimaryGradient,
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  label: {
    display: 'block',
    fontSize: tokens.fontSizeBase200,
    color: ottoTokens.landingDimText,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBlockStart: tokens.spacingVerticalXXS,
  },
});

export const TrustStrip = () => {
  const styles = useStyles();

  return (
    <section className={styles.section} aria-label="Platform reach">
      <div className={styles.inner}>
        {TRUST_STATS.map((stat) => (
          <div key={stat.label} className={styles.item}>
            <Text className={styles.value}>{stat.value}</Text>
            <Text className={styles.label}>{stat.label}</Text>
          </div>
        ))}
      </div>
    </section>
  );
};
